export const paymentBreakpoints = {
  smallMobile: 330,
  smallDesktop: 1381,
} as const;
